import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private popupVisibility = new BehaviorSubject<boolean>(false);
  public isPopupVisible = this.popupVisibility.asObservable();

  constructor() { }

  open(): void {
    this.popupVisibility.next(true);
  }

  close(): void {
    this.popupVisibility.next(false);
  }
}
